/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TarePayload
 */
export interface TarePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: TarePayloadTypeEnum;
    /**
     * 
     */
    tareGrams: number;
    /**
     * 
     */
    xInterceptsBefore?: { [key: string]: number; } | null;
    /**
     * 
     */
    xInterceptsAfter?: { [key: string]: number; } | null;
}


/**
 * @export
 */
export const TarePayloadTypeEnum = {
    Tare: 'tare',
} as const;
export type TarePayloadTypeEnum = typeof TarePayloadTypeEnum[keyof typeof TarePayloadTypeEnum];


/**
 * Check if a given object implements the TarePayload interface.
 */
export function instanceOfTarePayload(value: object): value is TarePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'tare') return false;
    
    if ((!('tareGrams' in (value as Record<string, any>)) && !('tare_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['tareGrams'] === undefined && (value as Record<string, any>)['tare_grams'] === undefined)) return false;
    return true;
}

export function TarePayloadFromJSON(json: any): TarePayload {
    return TarePayloadFromJSONTyped(json, false);
}

export function TarePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'tareGrams': json['tare_grams'],
        'xInterceptsBefore': json['x_intercepts_before'] === undefined ? undefined : json['x_intercepts_before'] === null ? null : json['x_intercepts_before'],
        'xInterceptsAfter': json['x_intercepts_after'] === undefined ? undefined : json['x_intercepts_after'] === null ? null : json['x_intercepts_after'],
    };
}

export function TarePayloadToJSON(json: any): TarePayload {
    return TarePayloadToJSONTyped(json, false);
}

export function TarePayloadToJSONTyped(value?: TarePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'tare_grams': value['tareGrams'],
        'x_intercepts_before': value['xInterceptsBefore'],
        'x_intercepts_after': value['xInterceptsAfter'],
    };
}

